export const toTitleCase = (str) => {
    let tstr = str
        .split(/[_]/)
        .map((word, index) => {

            return (
                word.charAt(0).toUpperCase() +
                word.slice(1)
            );
        })
        .join(" ");
    return (tstr.split('-').map(e => e.charAt(0).toUpperCase() + e.slice(1))).join('-');
}
export const validateEmail = (email,setErrorMessage,fieldName) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
        setErrorMessage(fieldName, "Please enter valid email")
    }
    return regex.test(email);
}